import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectRedirectTo = "/";

const ProtectedButton = ({ children }) => {
  const { isInvitationActive = false } = useSelector(
    (state) => state?.invitationListEmails
  );
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const userToken = user?.token;
  if (!userToken && isInvitationActive === true) {
    return <Navigate to={ProtectRedirectTo} replace={true} />;
  }

  return children;
};

export default ProtectedButton;
